import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './Line.module.scss';
var LineState;
(function (LineState) {
    LineState["Completed"] = "completed";
    LineState["InProgress"] = "in_progress";
    LineState["Dormant"] = "dormant";
})(LineState || (LineState = {}));
const getProgressBarState = (activeIndex, position) => {
    if (position < activeIndex) {
        return LineState.Completed;
    }
    else if (position === activeIndex) {
        return LineState.InProgress;
    }
    return LineState.Dormant;
};
const Line = ({ activeIndex, position }) => {
    const state = getProgressBarState(activeIndex, position);
    return (_jsxs("span", { "data-testid": "progress-line", className: classNames('d-flex', 'flex-column', 'mx-1x', 'mt-1x', 'mt-md-1-5x', {
            [styles.inProgress]: state === LineState.InProgress,
            [styles.completed]: state === LineState.Completed,
        }), children: [_jsx("span", { className: classNames(styles.line, styles.indicator) }), _jsx("span", { className: classNames(styles.line, styles.fullWidth) }), _jsx("span", { className: classNames(styles.line, styles.indicator) })] }));
};
export { Line };
